import { Translation } from '@ps/web-shared-components';
import React from 'react';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';

import Content from './Content';
import styles from './NewUser.scss';
import {
  TXTWCL_Create_your_own_club_and_invit_ELL,
  TXTWCL_PLAY_CASH_GAMES_AND_TOURNAMENT_ELL
} from './Step2.messages.json';
import imagePNG from './assets/step2.png';
import image from './assets/step2.webp';

const Step2: React.FC = () => (
  <StarsWizard.Page name="Step2">
    <Content
      activePage={1}
      additionalText={
        <div className={styles.additionalText}>
          <Translation {...TXTWCL_Create_your_own_club_and_invit_ELL} />
        </div>
      }
      mainText={
        <div className={styles.mainText}>
          <Translation {...TXTWCL_PLAY_CASH_GAMES_AND_TOURNAMENT_ELL} />
        </div>
      }
      pngImage={imagePNG}
      webPImage={image}
    />
  </StarsWizard.Page>
);

Step2.displayName = 'Step2';

export default Step2;
